// Shared world-size constant (mirrors server WorldSize).
export const WORLD = 160;
